import React from 'react';
export function BrandIntro() {
  return <section className="bg-orla-bone py-16 md:py-32" data-id="element-19">
      <div className="max-w-[1240px] mx-auto px-6" data-id="element-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16" data-id="element-21">
          {/* Left Column */}
          <div className="md:col-span-6 flex flex-col justify-center" data-id="element-22">
            <span className="font-body font-semibold text-[13px] text-orla-saffron uppercase tracking-[0.06em]" data-id="element-23">
              HOW ORLA WORKS
            </span>
            <h2 className="mt-4 font-display font-black text-[32px] md:text-[48px] text-orla-ink tracking-tight leading-[1.1]" data-id="element-24">
              Perimenopause care, made simple.
            </h2>
            <p className="mt-6 font-body text-[17px] text-orla-muted max-w-[480px] leading-relaxed" data-id="element-25">
              Orla is a telehealth practice built around one idea — that women
              deserve expert hormone care years before menopause hits. Our
              board-certified physicians, custom-compounded treatments, and
              unlimited follow-ups meet you exactly where you are. No waiting
              rooms, no dismissals, no guesswork.
            </p>
          </div>

          {/* Right Column */}
          <div className="md:col-span-6 flex flex-col" data-id="element-26">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(31,27,23,0.08)] group cursor-pointer" data-id="element-27">
              <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&fit=crop" alt="Physician and patient in a warm natural light setting" className="w-full h-full object-cover" data-id="element-28" />
              <div className="absolute inset-0 flex items-center justify-center bg-black/10" data-id="element-29">
                <div className="w-[72px] h-[72px] rounded-full bg-orla-sienna flex items-center justify-center shadow-[0_0_24px_rgba(155,71,34,0.4)] transition-transform duration-300 group-hover:scale-105" data-id="element-30">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-orla-bone ml-1" data-id="element-31">
                    <path d="M8 5v14l11-7z" data-id="element-32" />
                  </svg>
                </div>
              </div>
            </div>
            <p className="mt-4 font-display italic text-[14px] text-orla-muted text-center" data-id="element-33">
              Watch a 90-second intro to how Orla works.
            </p>
          </div>
        </div>
      </div>
    </section>;
}